import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Skeleton } from '@achra/ui/skeleton';
interface ExpandableInfoSkeletonProps {
  isFirst?: boolean;
}
function ExpandableInfoSkeleton(t0) {
  const $ = _c(7);
  const {
    isFirst
  } = t0;
  const t1 = isFirst && "w-[35%]";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("bg-border h-6 w-[55%]", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <Skeleton className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Skeleton className="bg-border h-4 w-4" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="bg-accent flex w-full items-center justify-between gap-4 rounded-md px-3 py-2 shadow-lg">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export { ExpandableInfoSkeleton };